import NiceModal, { useModal } from '@ebay/nice-modal-react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Modal } from 'baby-design'
import React, { useState } from 'react'
import PurchaserFormGroup from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/components/MarkPurchasedModal/components/PurchaserFormGroup/PurchaserFormGroup'
import PurchasedQuantity from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/components/MarkPurchasedModal/components/PurchasedQuantity/PurchasedQuantity'
import TextInput from 'baby-design/components/input/TextInput/TextInput'
import css from './MarkPurchasedModal.styles.scss'

export const MarkPurchasedModal = NiceModal.create(() => {
  const modal = useModal()
  const [isSelfPurchase, setIsSelfPurchase] = useState<boolean>()
  const [purchasedQuantity, setPurchasedQuantity] = useState(1)
  const [purchaserName, setPurchaserName] = useState<string>()

  const handleClose = () => {
    setIsSelfPurchase(undefined)
    setPurchasedQuantity(1)
    setPurchaserName(undefined)
    modal.resolve(undefined)
    modal.hide()
  }

  const handlePurchaserNameChanged = (e: React.ChangeEvent<HTMLInputElement>) =>
    setPurchaserName(e.target.value)

  const handleSetSelfPurchase = (selfPurchase: boolean) => {
    setIsSelfPurchase(selfPurchase)
    setPurchaserName(undefined)
  }

  return (
    <Modal showCloseButton handleClose={handleClose} isOpen={modal.visible}>
      <h1>Mark as purchased</h1>
      <div className={css.MarkPurchasedModal}>
        <p className={css.MarkPurchasedModal__Subtitle}>
          Let us know if this item has been purchased so you don't receive
          multiples.
        </p>
        <div className={css.MarkPurchasedModal__RadioGroup}>
          <PurchaserFormGroup
            id="self_purchase"
            label="I purchased this"
            selected={isSelfPurchase === true}
            onSelected={() => handleSetSelfPurchase(true)}
          >
            <PurchasedQuantity
              quantity={purchasedQuantity}
              onQuantityChanged={setPurchasedQuantity}
            />
          </PurchaserFormGroup>
          <PurchaserFormGroup
            id="other_purchase"
            label="Someone else purchased this"
            selected={isSelfPurchase === false}
            onSelected={() => handleSetSelfPurchase(false)}
          >
            <div />
            <TextInput
              label="Purchaser's name"
              size="md"
              value={purchaserName}
              onChange={handlePurchaserNameChanged}
            />
            <PurchasedQuantity
              quantity={purchasedQuantity}
              onQuantityChanged={setPurchasedQuantity}
            />
          </PurchaserFormGroup>
        </div>
      </div>
    </Modal>
  )
})
